import React from "react";
import Modal from "react-bootstrap/Modal";
import { Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { NameComparison } from "../models/dashboard-models";
import { ClientWarning, RegistrySource } from "../utils/Enums/ClientWarnings";
import { diffNames, NameDiffPart } from "../utils/name-diff";

type ConfirmModalProps = {
  show: boolean;
  onConfirm: () => void;
  onCancel: () => void;
  warnings: string[];
  /** При разминаване с регистъра: двете имена, разликите се оцветяват. */
  nameComparison?: NameComparison | null;
  /** Записва с името от регистъра вместо въведеното. */
  onUseOfficialName?: () => void;
};

const NameLine: React.FC<{ label: string; parts: NameDiffPart[] }> = ({ label, parts }) => (
  <div className="mb-2">
    <div className="small text-muted">{label}</div>
    <div className="fs-5">
      {parts.map((part, idx) => (
        <React.Fragment key={`${part.text}-${idx}`}>
          {idx > 0 ? " " : ""}
          <span className={part.changed ? "text-danger fw-bold text-decoration-underline" : undefined}>{part.text}</span>
        </React.Fragment>
      ))}
    </div>
  </div>
);

const ConfirmModal: React.FC<ConfirmModalProps> = ({
  show,
  onConfirm,
  onCancel,
  warnings,
  nameComparison,
  onUseOfficialName,
}) => {
  const { t } = useTranslation("translation", { keyPrefix: "common"})
  const diff = nameComparison ? diffNames(nameComparison.entered, nameComparison.official) : null;
  const companyDeleted = warnings.includes(ClientWarning.CompanyDeleted);
  return (
    <Modal show={show} onHide={onCancel} centered size="lg">
      <Modal.Header closeButton>
        <Modal.Title>{t("areYouSure")}</Modal.Title>
      </Modal.Header>

      <Modal.Body>
          {warnings.length === 0 ? (
              <div className="text-muted">{}</div>
          ) : (
              <div>
                  {warnings?.map((key) => (
                      <div key={key} className="text-danger mb-1">
                          {t(key)}
                      </div>
                  ))}
              </div>
          )}
          {nameComparison && diff && (
              <div className="mt-3">
                  <NameLine
                      label={t(nameComparison.source === RegistrySource.Bulstat ? "nameInBulstat" : "nameInCommercialRegister")}
                      parts={diff.official}
                  />
                  <NameLine label={t("enteredName")} parts={diff.entered} />
              </div>
          )}
      </Modal.Body>
        <Modal.Footer>
        <Button variant="secondary" onClick={onCancel}>
          {t("cancel")}
        </Button>
        {nameComparison && onUseOfficialName && (
          // Заличена фирма не може да стане клиент, затова и с името от регистъра записът ще бъде отказан.
          <Button variant="outline-primary" onClick={onUseOfficialName} disabled={companyDeleted}>
            {t("useRegistryName")}
          </Button>
        )}
        {/* Заличена фирма: бекендът отказва записа, затова остава само „Откажи". */}
        <Button variant="primary" onClick={onConfirm} disabled={companyDeleted}>
          {t("save")}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ConfirmModal;
